<div class="kexp-mini-playlist">
  @for (track of recentTracks(); track track.uid) {
    @if (track.content) {
      <div class="pt-2 border-b-1 border-default-700">
        <mini-track-card [item]="track" eventSource="recently_played"></mini-track-card>
      </div>
    }
  }
</div>
